// HOW A TYPED SEARCH ORDERS ITS MATCHES (QA 2026-10-04, C1-04; D-295, D-296).
//
// Exact, then starts-with, then a word starts with it, then anything else that
// matched — by name or by ID, whichever ranks better. One rule for the app's
// pickers (`app/src/lib/optionSearch.ts`) and the server's vendor search
// (`GET /vendors?q=`), so a short exact vendor name is in the first page the
// server returns, not past its cap. `backend/src/repo/pg/masters.ts` states the
// same rule in SQL (`vendorSearchSort`), and the in-memory repository in
// `app/mock/server/repo/masters.ts` calls this function. `searchRank.test.ts`
// holds this function's cases; the SQL is checked against it on a real Postgres
// in `backend/src/repo/pg/vendorSearch.test.ts`.

/** Lower case, with every run of punctuation or spaces made one space. */
export function searchWords(value: string): string {
  return value.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim()
}

/** Lower case, letters and digits only: `67-518` and `67518` read the same. */
export function searchCompact(value: string): string {
  return value.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '')
}

/** 0 exact, 1 starts with, 2 a word starts with, 3 any other match. */
export function searchRank(candidates: readonly (string | null | undefined)[], query: string): number {
  const needle = searchWords(query)
  if (needle === '') return 3
  const needleCompact = searchCompact(query)
  let best = 3
  for (const raw of candidates) {
    if (!raw) continue
    const text = searchWords(raw)
    if (text === needle || (needleCompact !== '' && searchCompact(raw) === needleCompact)) return 0
    if (text.startsWith(needle) || (needleCompact !== '' && searchCompact(raw).startsWith(needleCompact))) {
      best = Math.min(best, 1)
    } else if (` ${text}`.includes(` ${needle}`)) best = Math.min(best, 2)
  }
  return best
}
